export const primaryTopics = [
  'Cody',
  'VS Code',
  'JetBrains',
  'Enterprise',
  'Cody Web',
  'Code Search',
  'Visual Studio',
]

export const secondaryTopics = [
  'Autocomplete',
  'Chat',
  'Code Monitors',
]
